var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicWhiteMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 9.625C13.3726 10.473 13.1237 11.3021 12.6587 12.0113C12.1937 12.7205 11.5327 13.2792 10.7559 13.6196C9.97919 13.96 9.12028 14.0672 8.28369 13.9284C7.44709 13.7895 6.66889 13.4105 6.04375 12.8375L6.93125 11.9562C7.38145 12.3539 7.93672 12.6134 8.53057 12.7036C9.12442 12.7938 9.7317 12.711 10.2797 12.465C10.8277 12.2191 11.2932 11.8204 11.6205 11.3167C11.9477 10.813 12.1229 10.2257 12.125 9.625V6.7625L17.75 1.1375L16.8687 0.25L0.25 16.8687L1.13125 17.75L5.15625 13.725C6.03843 14.5583 7.16867 15.0806 8.375 15.2125V16.5H5.875V17.75H12.125V16.5H9.625V15.2125C10.9996 15.0588 12.2694 14.4041 13.1917 13.3733C14.1141 12.3426 14.6243 11.0082 14.625 9.625V7.75H13.375V9.625ZM4.625 9.825V7.75H3.375V9.625C3.37581 10.065 3.42825 10.5034 3.53125 10.9312L4.625 9.825ZM11.975 2.4875C11.7492 1.78347 11.2811 1.18229 10.6539 0.790823C10.0267 0.399351 9.28101 0.242941 8.54936 0.349389C7.81771 0.455838 7.1475 0.818251 6.65785 1.37222C6.16819 1.92618 5.89081 2.63582 5.875 3.375V8.5875L11.975 2.4875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicWhiteMuteIcon);
export default __webpack_public_path__ + "static/media/mic-white-mute-icon.f69475a07c3e7e05b3a1fb2cd2178cdc.svg";
export { ForwardRef as ReactComponent };